import { Injectable, Type, ViewContainerRef } from "@angular/core";
import { MLLog } from "../../../../base/lib/logger/Logger";
import { BehaviorSubject, Observable } from "rxjs";

export class GlassLayer {
    // Riferimento al singolo ViewContainerRef del Componente Host.
    private viewContainerRef: ViewContainerRef | null = null;
    private currentComponentRef: any | null = null;

    // Emettiamo solo un flag che indica se il layer è attivo o meno.
    private isActiveSubject = new BehaviorSubject<boolean>(false);
    public isActive$: Observable<boolean> = this.isActiveSubject.asObservable();

    constructor() { }

    /**
     * Registra l'unico ViewContainerRef fornito dal componente Host.
     */
    public registerContainer(vcr: ViewContainerRef): void {
        this.viewContainerRef = vcr;
        // Se c'era contenuto in coda (scenario raro qui), lo caricherebbe ora.
    }

    /**
     * Carica e visualizza dinamicamente un componente nel singolo layer.
     * Chiude il componente precedente se ne esiste uno.
     * Il Service è ora agnostico ai dati di Input.
     */
    public openComponent(componentType: Type<any>): any {
        if (!this.viewContainerRef) {
            MLLog.logError('Impossibile aprire il componente: VCR non registrato.');
            return;
        }

        // 1. Chiude e pulisce l'elemento precedente
        this.closeComponent();

        // 2. Creazione dell'istanza del nuovo componente
        const componentRef = this.viewContainerRef.createComponent(componentType);

        // 3. Rimosso: Nessun passaggio di dati programmatico tramite Input.
        //    Il componente dinamico deve ora recuperare i dati da un servizio.

        this.currentComponentRef = componentRef;
        this.isActiveSubject.next(true);

        //MLLog.logDev("Component was created")

        // Fornisce il riferimento per la rimozione manuale
        return componentRef;
    }

    /**
     * Rimuove il componente dinamico dal layer.
     */
    public closeComponent(): void {
        if (this.viewContainerRef) {
            this.viewContainerRef.clear(); // Rimuove tutte le viste dal container
        }
        this.currentComponentRef = null;
        this.isActiveSubject.next(false);
        //MLLog.logDev("SingleLayerService: Componente chiuso e VCR pulito.");
    }
}